import React from 'react'

import {Offer} from '../Offer/Offer'
import {useOffersList} from './hooks'
import type {Props} from './types'

export function OfferList(props: Props): React.ReactElement<Props> {
  const {offers, currencySign, country, isPending = false} = props
  const {field, fieldState} = useOffersList(props)

  return (
    <React.Fragment>
      {offers.map(offer => (
        <Offer
          key={offer.tariff}
          country={country}
          currencySign={currencySign}
          errorMessage={fieldState.error?.message}
          isPending={isPending}
          offer={offer}
          onChange={field.onChange}
          value={field.value}
        />
      ))}
    </React.Fragment>
  )
}
